import { Button, DataTable, ResultsCard, ResultsToolbar } from 'shared/components/ui';
import React, { useState, useEffect } from 'react';
import { Save } from '@mui/icons-material';

import { rolesAPI } from '../services/rolesAPI';
import { ToastContainer } from '../../../shared/components';
import './TablaRoles.css';

const TablaMenus = ({ roles, menus, loading }) => {
  const [permisos, setPermisos] = useState({});
  const [hasChanges, setHasChanges] = useState(false);
  const [saving, setSaving] = useState(false);
  const [toast, setToast] = useState(null);

  // Organizar menús en jerarquía
  const menusJerarquicos = menus.filter(m => !m.idMenuPadre);
  const subMenusPorPadre = menus.reduce((acc, menu) => {
    if (menu.idMenuPadre) {
      if (!acc[menu.idMenuPadre]) acc[menu.idMenuPadre] = [];
      acc[menu.idMenuPadre].push(menu);
    }
    return acc;
  }, {});

  useEffect(() => {
    const initialPermisos = {};
    roles.forEach(rol => {
      initialPermisos[rol.id] = rol.menusPermitidos || [];
    });
    setPermisos(initialPermisos);
    setHasChanges(false);
  }, [roles]);

  const handleToggleMenu = (rolId, menuId) => {
    setPermisos(prev => {
      const rolPermisos = prev[rolId] || [];
      const newPermisos = rolPermisos.includes(menuId)
        ? rolPermisos.filter(id => id !== menuId)
        : [...rolPermisos, menuId];
      
      setHasChanges(true);
      return { ...prev, [rolId]: newPermisos };
    });
  };

  const handleGuardarCambios = async () => {
    setSaving(true);
    try {
      await Promise.all(
        Object.entries(permisos).map(([rolId, menusPermitidos]) =>
          rolesAPI.updatePermisosMenus(parseInt(rolId), menusPermitidos)
        )
      );
      setHasChanges(false);
      setToast({ message: 'Permisos de menús actualizados correctamente', type: 'success' });
    } catch (error) {
      console.error('Error al guardar cambios:', error);
      setToast({ message: 'Error al guardar los cambios', type: 'error' });
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <ToastContainer toast={toast} onClose={() => setToast(null)} />
      <ResultsCard className="results-card">
      <ResultsToolbar className="results-header">
        <div className="results-header-left">
          <h3 className="results-title">Permisos de Menús por Rol</h3>
          <span className="results-subtitle">Selecciona los menús que cada rol puede visualizar</span>
        </div>
        <div className="results-info">
          <Button
            variant="success" 
            size="sm" 
            onClick={handleGuardarCambios}
            className="btn-save-changes"
            disabled={loading || !hasChanges || saving}
          >
            <Save sx={{ fontSize: 18, mr: 0.5 }} />
            {saving ? 'Guardando...' : 'Guardar Cambios'}
          </Button>
        </div>
      </ResultsToolbar>

      <div className="table-container">
        <DataTable className="data-table roles-table">
          <tbody>
            <tr>
              <th className="rol-column">Rol</th>
              {roles.map(rol => (
                <td key={rol.id} className="rol-name">{rol.nombre}</td>
              ))}
            </tr>
            {menusJerarquicos.map(menu => (
              <React.Fragment key={menu.id}>
                <tr>
                  <th className="estado-column menu-principal" colSpan={roles.length + 1}>{menu.nombre}</th>
                </tr>
                {subMenusPorPadre[menu.id]?.map(submenu => (
                  <tr key={submenu.id}>
                    <th className="estado-column submenu-column">{submenu.nombre}</th>
                    {roles.map(rol => (
                      <td key={rol.id} className="checkbox-cell">
                        <input
                          type="checkbox"
                          className="estado-checkbox"
                          checked={permisos[rol.id]?.includes(submenu.id) || false}
                          onChange={() => handleToggleMenu(rol.id, submenu.id)}
                          disabled={loading || saving}
                        />
                      </td>
                    ))}
                  </tr>
                ))}
              </React.Fragment>
            ))}
          </tbody>
        </DataTable>
      </div>
    </ResultsCard>
    </>
  );
};

export default TablaMenus;
